import { useCallback, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useLocationSegments } from "../../../../../hooks/use-location-segments";
export function useLoginState() {
    const navigate = useNavigate();
    const { segments } = useLocationSegments();
    const { formState: { errors, isValid }, handleSubmit: submitForm, register, } = useForm({
        mode: "all",
        defaultValues: {
            email: "",
            password: "",
            remember_me: true,
        },
    });
    const [showPassword, setShowPassword] = useState(false);
    const canSubmit = useMemo(() => !!isValid, [isValid]);
    const lastSegment = useMemo(() => (segments ? segments?.[segments?.length - 1] : "login"), [segments]);
    const title = useMemo(() => (lastSegment === "login" ? "Sign In" : "Sign Up"), [lastSegment]);
    const handleForgotPasswordClicked = useCallback(() => {
        navigate("/auth/forgot-password");
    }, []);
    const handleTogglePassword = useCallback(() => {
        setShowPassword((prevValue) => !prevValue);
    }, []);
    return useMemo(() => ({
        canSubmit,
        errors,
        handleForgotPasswordClicked,
        handleTogglePassword,
        register,
        showPassword,
        submitForm,
        title,
    }), [canSubmit, errors, handleForgotPasswordClicked, handleTogglePassword, register, showPassword, submitForm, title]);
}
